// extracted by mini-css-extract-plugin
module.exports = {"mainDivPO":"purchaseOrder_mainDivPO__2oyJo","leftDivPO":"purchaseOrder_leftDivPO__1B9qa","rightDivPO":"purchaseOrder_rightDivPO__3XU3D"};